/* eslint-disable max-len */
import Phaser from 'phaser';

import DragPolygon from '../entities/DragPolygon';
import Ball from '../entities/Ball';
import Joystick from '../entities/Joystick';
import Maze from '../entities/Maze';
import Point from '../entities/Point';
import Message from '../entities/Message';

import pointsData from '../data/pointsData';
import joystickData from '../data/joystickData';
import ballData from '../data/ballData';
import mazeData from '../data/mazeData';
import messageData from '../data/messageData';

import config from '../config';
import pageParams from '../pageParams';

class GameScene extends Phaser.Scene {
    constructor() {
        super('GameScene');
    }

    create() {
        this.isShowMessage = false;
        this.isMoveAbility = false;
        this.hold = false;
        this.exit = false;
        this.keysDown = [];
        this.isShowStartLogoComplete = false;
        this.isHideStartLogoComplete = false;
        this.isChangeTo = '';
        this.createPoints();
        this.createBall();
        this.createMaze();
        this.createJoystick();
        this.createDragPolygon();
        this.addOverlap();
        this.createMessage();
        this.createSiteBall();

        this.sys.game.onGameSceneCreate();

        this.input.keyboard.on('keydown', (event) => this.onKeyDown(event));
        this.input.keyboard.on('keyup', (event) => this.onKeyUp(event));

        // this.qwe = this.add.circle(0, 0, 600, 0x000000, 1);
        // this.asd = this.add.sprite(40, 40, 'ballpng');
        // this.asd
        // console.log(this.asd);
    }

    update() {
        if (!this.isShowStartLogoComplete && this.sys.game.isShowStartLogoComplete) this.onShowLogoComplete();
        if (!this.isHideStartLogoComplete && this.sys.game.isHideStartLogoComplete) this.onStartAnimationComplete();
        if (!this.exit && this.checkForwardButtonClick()) this.exitAnimation();
        if (this.sys.game.isChangePage && this.isChangeTo === '') {
            this.isChangeTo = this.sys.game.to;
        }
        if (!this.sys.game.isChangePage && this.isChangeTo !== '') {
            this.getPageAnimation(this.isChangeTo);
            this.isChangeTo = '';
        }
    }

    onKeyDown(event) {
        if (!this.hold && this.isMoveAbility && !this.dragPolygon.isPush) {
            const { key } = event;
            if (!this.keysDown.includes(key)) {
                // const { x, y } = this.joystick.getDefaultCoord();
                // this.joystick.changeVisibility(true, x, y);
                const arrow = {
                    x: (key === 'ArrowLeft' && -1) || (key === 'ArrowRight' && 1) || 0,
                    y: (key === 'ArrowDown' && 1) || (key === 'ArrowUp' && -1) || 0,
                };
                const { velocity } = this.ball.body;
                // console.log(arrow);
                this.ball.body.setDrag(0);
                if (arrow.x !== 0) this.ball.body.setVelocity(arrow.x * 100, velocity.y);
                if (arrow.y !== 0) this.ball.body.setVelocity(velocity.x, arrow.y * 100);
                // this.ball.push((arrow.x * this.joystick.radius - x) * 1.2, (arrow.y * this.joystick.radius - y) * 1.2);
                // this.joystick.changeJoystickPosition(arrow.x * this.joystick.radius, arrow.y * this.joystick.radius);
                this.keysDown.push(key);
                this.joystick.changeVisibility(false);
            }
        }
    }

    onKeyUp(event) {
        if (this.keysDown.length > 0 && this.isMoveAbility) {
            const { key } = event;
            if (this.keysDown.includes(key)) {
                const { velocity } = this.ball.body;
                this.ball.body.setDrag(0);
                if (key === 'ArrowLeft' || key === 'ArrowRight') this.ball.body.setVelocity(0, velocity.y);
                if (key === 'ArrowUp' || key === 'ArrowDown') this.ball.body.setVelocity(velocity.x, 0);
                this.keysDown.splice(this.keysDown.indexOf(key), 1);
            }
        }
    }

    checkForwardButtonClick() {
        return this.sys.game.isForwardButtonClick;
    }

    onStartAnimationComplete() {
        this.sys.game.handleShowLogoAndRule();
        this.isHideStartLogoComplete = true;
        this.joystick.getDefaultPosition();
        this.ball.show();
    }

    createMessage() {
        const { [pageParams.screenSize]: { x, y, fontSize } } = messageData;
        this.message = new Message(this, pageParams.offsetLeft + x, pageParams.offsetTop + y, fontSize);
    }

    createDragPolygon() {
        this.dragPolygon = new DragPolygon(this, pageParams.clientWidth, pageParams.clientHeight);
    }

    createPoints() {
        this.points = pointsData.map(({
            [pageParams.screenSize]: {
                x, y, diameter, text,
            },
        }) => new Point(this, x, y, diameter, text, {
            offsetX: pageParams.offsetLeft,
            offsetY: pageParams.offsetTop,
        }));
    }

    createBall() {
        const { [pageParams.screenSize]: { gameCoord: { x, y }, gameDiameter } } = ballData;
        this.ball = new Ball(this, pageParams.offsetLeft + x, pageParams.offsetTop + y, gameDiameter, 'gameBall');
    }

    createSiteBall() {
        const { [pageParams.screenSize]: { siteDiameter } } = ballData;
        this.siteBall = new Ball(this, 0, 0, siteDiameter, 'siteBall');
        this.siteBall.setAlpha(0);
    }

    createMaze() {
        const {
            [pageParams.screenSize]: {
                x, y, maze, shadowOffset, finishData = null,
            },
        } = mazeData;
        this.maze = new Maze(this, pageParams.offsetLeft + x, pageParams.offsetTop + y, maze, shadowOffset, finishData, this.sys.game.isRenderGame);
    }

    createJoystick() {
        const {
            [pageParams.screenSize]: { stickDiameter, ringDiameter, defaultPosition },
        } = joystickData;
        this.ring = this.add.image(0, 0, 'ring');
        this.joystick = new Joystick(this, stickDiameter, ringDiameter, {
            ...defaultPosition,
            offsetX: pageParams.offsetLeft,
            offsetY: pageParams.offsetTop,
        });
    }

    addOverlap() {
        this.physics.add.overlap(this.ball, this.points, this.onPointOverlap, null, this);
        this.physics.add.overlap(this.ball, this.maze.exit, this.onExitOverlap, null, this);
    }

    hideMessage(callback) {
        this.message.hide(() => {
            this.isShowMessage = false;
            if (callback) callback();
        });
    }

    onShowLogoComplete() {
        this.isShowStartLogoComplete = true;
        this.timer = this.time.addEvent({
            delay: config.startAnimationDelay,
            callback: this.startAnimation,
            callbackScope: this,
        });
    }

    startAnimation() {
        this.sys.game.handleStartAnimation();
        this.maze.show();
    }

    showMessage(text) {
        if (!this.isShowMessage) this.message.show(text);
    }

    onPointOverlap(ball, point) {
        const { isPassed } = point;
        if (!isPassed) {
            const {
                text,
            } = point;

            if (this.isShowMessage) {
                this.hideMessage(() => {
                    this.showMessage(text);
                    this.isShowMessage = true;
                });
            } else {
                this.showMessage(text);
                this.isShowMessage = true;
            }
            point.pass();
        }
    }

    onExitOverlap() {
        if (!this.exit) this.exitAnimation();
    }

    exitAnimation() {
        this.exit = true;
        this.isMoveAbility = false;
        this.tweens.add({
            targets: [this.ball, this.message],
            alpha: 0,
            ease: 'Cubic.easeInOut',
            duration: config.finishAnimationDuration,
            onComplete: () => this.sys.game.handleExitGame(),
        });
        this.joystick.changeVisibility(false);
        this.sys.game.handleHideRule();
        this.sys.game.handleHideForwardButton();
        this.sys.game.handleExitAnimation();

        this.maze.exitAnimation(config.finishAnimationDuration);
        // this.points.forEach((point) => point.takeFinishPosition(config.finishAnimationDuration));
    }

    mainPageAnimation() {
        this.siteBall.setAlpha(0);
        this.maze.mainPageAnimation();
    }

    researchPageAnimation() {
        this.siteBall.setAlpha(0);
        this.maze.researchPageAnimation(() => this.siteBall.researchPageAnimation());
    }

    designPageAnimation() {
        this.siteBall.setAlpha(0);
        this.maze.designPageAnimation(() => this.siteBall.designPageAnimation());
    }

    launchPageAnimation() {
        this.siteBall.setAlpha(0);
        this.maze.launchPageAnimation(() => this.siteBall.launchPageAnimation());
    }

    pageWithoutMaze() {
        this.maze.setAlpha(0);
        this.siteBall.setAlpha(0);
    }

    getPageAnimation(path) {
        switch (path) {
        case '/':
            this.mainPageAnimation();
            break;
        case '/direction/research':
            this.researchPageAnimation();
            break;
        case '/direction/design':
            this.designPageAnimation();
            break;
        case '/direction/launch':
            this.launchPageAnimation();
            break;
        default:
            this.pageWithoutMaze();
            break;
        }
    }
}

export default GameScene;
